// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1w_qP","rootSuccess":"CompleteLink_rootSuccess__2WcNN","rootFailure":"CompleteLink_rootFailure__raMJx","isDisabled":"CompleteLink_isDisabled__Xln5O"};